import React, { useState } from "react";
import Button from "../components/common/Button";
import FormError from "../components/common/FormError";
import FormSuccess from "../components/common/FormSuccess";
import Label from "../components/common/Label";

const RecoveryPswrdModal = ({
  closeModal,
  Title,
  resetMsgs,
  onSubmitForgotPwrd,
  BtnAttr,
}) => {
  const [adNum, setAdNum] = useState("");

  return (
    <>
      <>
        <div className='w-full justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
          <div className='relative my-6'>
            <div className='border-0 rounded-lg shadow-lg w-10/12 sm:w-7/12 p-5 sm:p-8 relative flex flex-col mx-auto bg-white outline-none focus:outline-none'>
              <div className='flex justify-between rounded-t'>
                <div className='text-base leading-6 font-semibold'>
                  <Title />
                </div>
                <button
                  className='p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none'
                  onClick={closeModal}>
                  <svg
                    width='14'
                    height='14'
                    viewBox='0 0 14 14'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M1 1L13 13M1 13L13 1L1 13Z'
                      stroke='#C6C6CA'
                      stroke-width='2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                </button>
              </div>
              <div className='py-2'>
                {resetMsgs.recoveryPswrdSuccessMsg && (
                  <FormSuccess text={resetMsgs.recoveryPswrdSuccessMsg} />
                )}
                {resetMsgs.recoveryPswrdErrMsg && (
                  <FormError text={resetMsgs.recoveryPswrdErrMsg} />
                )}
                <div className='mb-2 w-full sm:w-3/4'>
                  <div className='mb-1'>
                    <Label text='Admission Number' />
                  </div>
                  <input
                    className='appearance-none relative block w-full px-3 py-2 bg-blue-900 border border-blue-800 placeholder-gray-500 text-gray-200 rounded-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5'
                    aria-label='Admission Number'
                    name='admissionnumber'
                    type='text'
                    value={adNum}
                    onChange={(e) => setAdNum(e.target.value)}
                  />
                </div>
                <span className='text-sm text-gray-400 leading-5'>
                  A recovery code would be sent to the phone number and email
                  address registered with the admission number provided
                </span>
                <div className='mt-6 w-36'>
                  <Button
                    type='submit'
                    text='Get recovery code'
                    loading={BtnAttr}
                    onClick={() => onSubmitForgotPwrd(adNum)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className='opacity-25 fixed inset-0 z-40 bg-black'
          onClick={closeModal}></div>
      </>
    </>
  );
};

export default RecoveryPswrdModal;
